import { apiWrapper, apiCancel } from "../../wrapper";

export const initial = "cpns";
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL;
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE;
const outputType = "json";

// master data
export const masterRegion = "Master/List/region/";
export const masterEducation = "Master/List/education/";
export const masterRank = "Master/List/rank/";
export const masterPosition = "Master/List/position/";
export const masterWorkUnit = "Master/List/workUnit/";
export const masterGajiwebAgama = "Master/GajiWeb/listAgama/";
export const masterGajiwebSatker = "Master/GajiWeb/listSatker/";
export const masterBank = "Master/Bank/list/";
export const masterGajiwebBankSpan = "Master/GajiWeb/listBankSpan/";
export const masterEmployeeCategories = "Master/GajiWeb/listJenisPns/";
export const masterEmployee = "Master/GajiWeb/listPegawai/";

export const cpnsPeriodCreate = "Kepegawaian/CPNS/createPeriod/";
export const cpnsPeriodList = "Kepegawaian/CPNS/listPeriod/";
export const cpnsPeriodDetail = "Kepegawaian/CPNS/detailPeriod/";
export const cpnsPeriodInactive = "Kepegawaian/CPNS/deletePeriode/";
export const cpnsPeriodActive = "Kepegawaian/CPNS/activePeriod/";

export const cpnsGetProjection = "Kepegawaian/CPNS/getProjectionCPNS/";
export const cpnsList = "Kepegawaian/CPNS/listCandidate/";
export const cpnsDelete = "Kepegawaian/CPNS/delete/";
export const cpnsActive = "Kepegawaian/CPNS/active/";
export const cpnsExportUsulan = "Kepegawaian/CPNS/exportExcelUsulan/";
export const cpnsExportLampiran = "Kepegawaian/CPNS/exportExcelLampiran/";
export const cpnsCreate = "Kepegawaian/CPNS/create/";
export const cpnsDetail = "Kepegawaian/CPNS/detail/";
export const cpnsUploadSK = "Kepegawaian/CPNS/uploadSK/";
export const cpnsCreateDecreeCollective =
  "Kepegawaian/CPNS/createDecreeCollective/";
export const cpnsDetailDecreeCollective =
  "Kepegawaian/CPNS/detailDecreeCollective/";

export const cpnsDownloadSKCollective =
  "Kepegawaian/CPNS/downloadSKCollective/";
export const cpnsDownloadDraftSK = "Kepegawaian/CPNS/downloadDraftSK/";
export const cpnsImportExcel = "Kepegawaian/CPNS/importExcel/";

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
  return apiCancel();
};
export const apiRequest = async (
  method,
  route,
  data = { params: null, body: null, cancelToken: null },
  needToken = true
) => {
  if (needToken) {
    const thisTime = Math.floor(Date.now() / 1000);
    const expire = localStorage.getItem(initial + "accessExpired");
    if (expire < thisTime) {
      await apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        "post",
        "auth/getAccessToken/",
        data
      )
        .then((result) => {
          localStorage.setItem(
            initial + "accessToken",
            result.response.access_token
          );
          return apiWrapper(
            baseUrl,
            initial,
            appCode,
            outputType,
            method,
            route,
            data
          );
        })
        .catch((result) => {
          return Promise.reject("Tidak dapat mengambil accessToken");
        });
    } else {
      return apiWrapper(
        baseUrl,
        initial,
        appCode,
        outputType,
        method,
        route,
        data
      );
    }
  }
  return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data);
};
